"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 *
 * @description TpmBuyCardGroup
 * @author xlongjiang
 * @created 2025-11-10 09:47:00
 */

const TabPanel = _tpmProductIntl.Tab.TabPanel;
const Row = _tpmProductIntl.Grid.Row,
  Col = _tpmProductIntl.Grid.Col;

/**
 * 格式化组件数据
 * @param properties 组件属性
 * @param options 选项
 * @returns 格式化后的数据
 */
const formatTpmBuyCardGroupData = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? '' : _ref$bgColor,
    _ref$bgImg = _ref.bgImg,
    bgImg = _ref$bgImg === void 0 ? '' : _ref$bgImg,
    _ref$tabList = _ref.tabList,
    tabList = _ref$tabList === void 0 ? [] : _ref$tabList;
  const handleTabList = tabList.map((tab, index) => {
    const _tab$text = tab.text,
      text = _tab$text === void 0 ? '' : _tab$text,
      columns = tab.columns,
      _tab$normalList = tab.normalList,
      normalList = _tab$normalList === void 0 ? [] : _tab$normalList,
      _tab$fullList = tab.fullList,
      fullList = _tab$fullList === void 0 ? [] : _tab$fullList;
    const handleNormalList = normalList.map((item, key) => {
      const _item$titleText = item.titleText,
        titleText = _item$titleText === void 0 ? '' : _item$titleText,
        _item$titleHref = item.titleHref,
        titleHref = _item$titleHref === void 0 ? '' : _item$titleHref,
        _item$configList = item.configList,
        configList = _item$configList === void 0 ? [] : _item$configList,
        _item$tagList = item.tagList,
        tagList = _item$tagList === void 0 ? [] : _item$tagList,
        _item$integerCost = item.integerCost,
        integerCost = _item$integerCost === void 0 ? '' : _item$integerCost,
        _item$decimalCost = item.decimalCost,
        decimalCost = _item$decimalCost === void 0 ? '' : _item$decimalCost,
        _item$priceUnit = item.priceUnit,
        priceUnit = _item$priceUnit === void 0 ? '' : _item$priceUnit,
        _item$originalCost = item.originalCost,
        originalCost = _item$originalCost === void 0 ? '' : _item$originalCost,
        _item$freeText = item.freeText,
        freeText = _item$freeText === void 0 ? '' : _item$freeText,
        _item$btnList = item.btnList,
        btnList = _item$btnList === void 0 ? [] : _item$btnList;
      const handleBtnList = btnList.map((btn, btnIndex) => {
        const _btn$type = btn.type,
          type = _btn$type === void 0 ? 'primary' : _btn$type,
          _btn$text = btn.text,
          text = _btn$text === void 0 ? '' : _btn$text,
          _btn$href = btn.href,
          href = _btn$href === void 0 ? '' : _btn$href;
        const btnExtendProps = {
          'report-event': 'click_BuyCard_Normal_btn',
          'report-ext1': index,
          'report-ext2': key,
          'report-ext3': btnIndex,
          target: '_blank'
        };
        if (type === 'weak') {
          return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
            type: "weak",
            href: href
          }, btnExtendProps), text);
        }
        return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
          href: href
        }, btnExtendProps), text);
      });
      return {
        title: titleText ? {
          text: titleText,
          href: titleHref !== null && titleHref !== void 0 ? titleHref : null,
          target: '_blank'
        } : null,
        configList,
        tagList,
        integerCost,
        decimalCost,
        priceUnit,
        originalCost,
        freeText,
        btn: !!btnList.length ? handleBtnList : null
      };
    });
    const handleFullList = fullList.map((item, key) => {
      const _item$badge = item.badge,
        badge = _item$badge === void 0 ? {} : _item$badge,
        _item$titleText2 = item.titleText,
        titleText = _item$titleText2 === void 0 ? '' : _item$titleText2,
        _item$titleHref2 = item.titleHref,
        titleHref = _item$titleHref2 === void 0 ? '' : _item$titleHref2,
        _item$subTitle = item.subTitle,
        subTitle = _item$subTitle === void 0 ? '' : _item$subTitle,
        _item$configList2 = item.configList,
        configList = _item$configList2 === void 0 ? [] : _item$configList2,
        _item$tagList2 = item.tagList,
        tagList = _item$tagList2 === void 0 ? [] : _item$tagList2,
        _item$integerCost2 = item.integerCost,
        integerCost = _item$integerCost2 === void 0 ? '' : _item$integerCost2,
        _item$decimalCost2 = item.decimalCost,
        decimalCost = _item$decimalCost2 === void 0 ? '' : _item$decimalCost2,
        _item$priceUnit2 = item.priceUnit,
        priceUnit = _item$priceUnit2 === void 0 ? '' : _item$priceUnit2,
        _item$originalCost2 = item.originalCost,
        originalCost = _item$originalCost2 === void 0 ? '' : _item$originalCost2,
        _item$freeText2 = item.freeText,
        freeText = _item$freeText2 === void 0 ? '' : _item$freeText2,
        _item$btnList2 = item.btnList,
        btnList = _item$btnList2 === void 0 ? [] : _item$btnList2;
      const handleBtnList = btnList.map((btn, btnIndex) => {
        const _btn$type2 = btn.type,
          type = _btn$type2 === void 0 ? 'primary' : _btn$type2,
          _btn$text2 = btn.text,
          text = _btn$text2 === void 0 ? '' : _btn$text2,
          _btn$href2 = btn.href,
          href = _btn$href2 === void 0 ? '' : _btn$href2;
        const btnExtendProps = {
          'report-event': 'click_BuyCard_Full_btn',
          'report-ext1': index,
          'report-ext2': key,
          'report-ext3': btnIndex,
          target: '_blank'
        };
        if (type === 'weak') {
          return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
            type: "weak",
            href: href
          }, btnExtendProps), text);
        }
        return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
          href: href
        }, btnExtendProps), text);
      });
      return {
        size: 'large',
        badge: badge.text ? badge : null,
        title: titleText ? {
          text: titleText !== null && titleText !== void 0 ? titleText : '',
          href: titleHref !== null && titleHref !== void 0 ? titleHref : null,
          target: '_blank'
        } : null,
        subTitle: subTitle ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
          html: subTitle
        }) : '',
        configList,
        tagList,
        integerCost,
        decimalCost,
        priceUnit,
        originalCost,
        freeText,
        btn: !!btnList.length ? handleBtnList : null
      };
    });
    return {
      text,
      columns,
      normalList: handleNormalList,
      fullList: handleFullList
    };
  });
  return {
    porintId,
    tag,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: desc
    }) : '',
    bg,
    bgColor,
    bgImg: (0, _componentUtils.doComponentsUploadEvent)(bgImg || '').url,
    tabList: handleTabList
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} "数据"表单内容
  style,
  // {object} "样式"表单内容
  commonStyle,
  // {object} "组件自定义样式"表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatTpmBuyCardGrou = formatTpmBuyCardGroupData(data, {
        domains
      }),
      porintId = _formatTpmBuyCardGrou.porintId,
      tag = _formatTpmBuyCardGrou.tag,
      title = _formatTpmBuyCardGrou.title,
      desc = _formatTpmBuyCardGrou.desc,
      bg = _formatTpmBuyCardGrou.bg,
      bgColor = _formatTpmBuyCardGrou.bgColor,
      bgImg = _formatTpmBuyCardGrou.bgImg,
      tabList = _formatTpmBuyCardGrou.tabList;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: `gems-materials-qci____newUI-TpmBuyCardGroup`
    }, (0, _reportUtil.reportShow)(['show_newUI_TpmBuyCardGroup', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      tag: tag,
      title: title,
      desc: desc,
      bg: bg,
      bgColor: bgColor,
      bgImg: bgImg
    }, tabList.length > 1 ? /*#__PURE__*/React.createElement(_tpmProductIntl.Tab, {
      itemList: tabList.map((item, index) => ({
        text: item.text,
        id: `id${index}`
      }))
    }, tabList.map((item, index) => /*#__PURE__*/React.createElement(TabPanel, {
      id: `id${index}`
    }, /*#__PURE__*/React.createElement(Row, {
      gap: 20,
      gutter: {
        whole: 4,
        pad: 4,
        phone: 4
      }
    }, item.normalList.map((card, key) => /*#__PURE__*/React.createElement(Col, {
      span: 24 / item.columns,
      pad: 24,
      phone: 24
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.BuyCard, Object.assign({}, card, {
      key: key
    })))), item.fullList.map((card, key) => /*#__PURE__*/React.createElement(Col, {
      span: 24,
      pad: 24,
      phone: 24
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.BuyCard, Object.assign({}, card, {
      key: key
    })))))))) : tabList.map((item, index) => /*#__PURE__*/React.createElement(Row, {
      gap: 20,
      gutter: {
        whole: 4,
        pad: 4,
        phone: 4
      }
    }, item.normalList.map((card, key) => /*#__PURE__*/React.createElement(Col, {
      span: 24 / item.columns,
      pad: 24,
      phone: 24
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.BuyCard, Object.assign({}, card, {
      key: key
    })))), item.fullList.map((card, key) => /*#__PURE__*/React.createElement(Col, {
      span: 24,
      pad: 24,
      phone: 24
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.BuyCard, Object.assign({}, card, {
      key: key
    }))))))));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}